import { render, staticRenderFns } from "./DepartAuthModal.vue?vue&type=template&id=173341e3&scoped=true"
import script from "./DepartAuthModal.vue?vue&type=script&lang=js"
export * from "./DepartAuthModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173341e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('173341e3')) {
      api.createRecord('173341e3', component.options)
    } else {
      api.reload('173341e3', component.options)
    }
    module.hot.accept("./DepartAuthModal.vue?vue&type=template&id=173341e3&scoped=true", function () {
      api.rerender('173341e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/DepartAuthModal.vue"
export default component.exports